import { ActivityLogList } from '../staff/ActivityLogList';

export const AuditLogPage = () => {
  return <ActivityLogList embedded={false} title="Audit log - Faoliyat tarixi" />;
};
